import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { IBasketItem } from './BasketStore'

interface IOrderSummary {
    items: IBasketItem[]
    subtotal: number
    delivery: number
    total: number
    region?: string
    discount?: {
        code: string
        amount: number
        type: 'percentage' | 'fixed' | 'free_addon' | 'free_delivery'
        value: number
    }
}

interface IOrderSummaryStore {
    currentOrder: IOrderSummary | null
    setCurrentOrder: (
        items: IBasketItem[],
        subtotal: number,
        delivery: number,
        region?: string,
        discount?: { code: string, amount: number, type: 'percentage' | 'fixed' | 'free_addon' | 'free_delivery', value: number }
    ) => void
    clearCurrentOrder: () => void
}

const useOrderSummaryStore = create<IOrderSummaryStore>()(
    persist(
        (set) => ({
            currentOrder: null,
            setCurrentOrder: (items, subtotal, delivery, region, discount) => set({
                currentOrder: {
                    items,
                    subtotal,
                    delivery,
                    region,
                    discount,
                    total: subtotal - (discount?.amount || 0) + delivery
                }
            }),
            clearCurrentOrder: () => set({ currentOrder: null })
        }),
        {
            name: 'order-summary-storage'
        }
    )
)

export default useOrderSummaryStore 
